/* eslint no-else-return: 0 */
import { mapGetters, mapState } from 'vuex';
import {
  NUMBER_HEIGHT_LIGHTBOX_MAX_RAW,
  NUMBER_WIDTH_LIGHTBOX_MAX_RAW,

  SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_LARGE,

  SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_LARGE,
  SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_LARGE,
} from '../../design-tokens/build/dictionary';
import { getNumberFromToken } from './../core/utils';

/**
 * @name SubmissionSize
 *
 */
export default {
  name: 'lightbox-size',
  computed: {
    /**
     * The proper top and height
     */
    lightboxStyle() {
      return {
        top: `${this.scrollTop}px`,
        height: `${this.viewportHeight}px`,
      };
    },
    resizeDims() {
      return this.getSize();
    },
    wrapperStyle() {
      return {
        height: `${Math.ceil(this.resizeDims.height)}px`,
        width: `${Math.ceil(this.resizeDims.width)}px`,
      };
    },
    targetHeight() {
      return this.contentDimensions.height;
    },
    minWidth() {
      return 0;
    },

    minHeight() {
      return 0;
    },

    maxContentHeight() {
      const marginBottom = this.smallDisplay
        ? SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_BOTTOM_VIDEO_LIGHTBOX_CONSTRAINT_LARGE;
      const marginTop = this.smallDisplay
        ? SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_TOP_VIDEO_LIGHTBOX_CONSTRAINT_LARGE;

      return getNumberFromToken(marginTop) + getNumberFromToken(marginBottom);
    },

    maxHeight() {
      const maxToFitInView = this.viewportHeight * NUMBER_HEIGHT_LIGHTBOX_MAX_RAW - this.maxContentHeight;

      // there was another value to compare here and I forget - AH

      return maxToFitInView;
    },

    maxContentWidth() {
      const margin = this.smallDisplay
        ? SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_VIDEO_LIGHTBOX_CONSTRAINT_LARGE;

      return getNumberFromToken(margin);
    },

    maxWidth() {
      const maxTokenWidthPercentage = this.smallDisplay ? 1 : NUMBER_WIDTH_LIGHTBOX_MAX_RAW;
      const maxToFitInView = this.viewportWidth * maxTokenWidthPercentage - this.maxContentWidth;

      return maxToFitInView;
    },

    aspectRatio() {
      return this.contentDimensions.width / this.contentDimensions.height;
    },

    ...mapState('windowMedia', [
      'scrollTop'
    ]),
    ...mapGetters('windowMedia', [
      'viewportHeight',
      'viewportWidth',
    ])
  },

  methods: {
    /**
     * Check that `value` satisfies the constraint `name`
     *
     * @param {any} value value to test
     * @param {any} name name of constraint
     * @returns {Boolean} `true` if value passes
     */
    checkConstraint(value, name) {
      if (!this[name]) {
        // can't fail if not set, 0 is the value for no constraint.
        return true;
      }

      let min = false; // if this is a minimum constraing

      if (name.indexOf('min') > -1) {
        min = true;
      }

      if (min && value > this[name]) {
        return true;
      } else if (!min && value < this[name]) {
        return true;
      }

      return false;
    },

    /**
     * Get get the correct dims for ratio given the target height.
     *
     * Checks that final values are under maxWidth and maxHeight and above minWidth and minHeight ONCE.
     *
     * @returns {{ Number, Number }}
     */
    getSize() {
      let height = this.checkConstraint(this.targetHeight, 'maxHeight')
        ? this.targetHeight
        : this.maxHeight;
      height = this.checkConstraint(height, 'minHeight')
        ? height
        : this.minHeight;

      let width = Math.ceil(height * this.aspectRatio);

      if (this.checkConstraint(width, 'maxWidth') && this.checkConstraint(width, 'minWidth')) {
        return {
          width,
          height,
        };
      } else if (!this.checkConstraint(width, 'maxWidth')) {
        // maxWidth failed
        width = this.maxWidth;
        height = Math.ceil(width / this.aspectRatio);

        return {
          width,
          height,
        };
      }

      // min width failed
      width = this.minWidth;
      height = width / this.aspectRatio;

      return {
        width,
        height,
      };
    },
  },
};
